import Image from "next/image";

type Props = {
  file: File | null;
  required?: boolean;
  onFileChange: (file: File | null) => void;
};

const FileUploader: React.FC<Props> = ({
  file,
  onFileChange,
  required = false,
}) => {
  return (
    <div className="bg-white p-4 flex flex-col border border-border grow h-[166px]">
      <label className="block text-primary-text text-subtitle-2 font-bold mb-3">
        Upload file{required && "*"}
      </label>
      <label
        htmlFor="file-upload"
        className="flex-[1] rounded flex items-center gap-4 bg-white cursor-pointer hover:bg-gray-50 p-4"
      >
        <div className="p-2">
          <figure className="bg-[linear-gradient(96.18deg,_#0086E6_0%,_#0469B1_100%)] px-2.5 py-[9px] outline-8 outline-[#EAF5FD]">
            <Image
              src="/images/upload_icon.svg"
              width={16.55}
              height={18}
              alt="upload icon"
              quality={80}
            />
          </figure>
        </div>
        <span className="block text-sm text-gray-700">
          {file ? file.name : "Upload document"}
        </span>
        <input
          id="file-upload"
          type="file"
          onChange={(e) => onFileChange(e.target.files?.[0] || null)}
          className="hidden"
        />
      </label>
    </div>
  );
};
export default FileUploader;